import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { Dispatch } from 'redux';
import TemplateRenderer from '../TemplateRenderer';
import { IStore } from 'redux/store';
import { inspectorSelectors } from 'redux/app/vessel/inspector';

type OwnProps = {
    bookId: string;
    zoomInRef: React.MutableRefObject<any>;
    zoomOutRef: React.MutableRefObject<any>;
    setDefaultStateRef: React.MutableRefObject<any>;
    transformComponentRef: React.MutableRefObject<any>;
    isDrag: boolean;
    isFullScreen: boolean;
};
type LogInspectorViewProps = PropsFromRedux & OwnProps;
function LogInspectorView(props: LogInspectorViewProps) {
    const {
        isDrag,
        isFullScreen,
        setDefaultStateRef,
        transformComponentRef,
        zoomInRef,
        zoomOutRef,
    } = props;

    return (
        <TemplateRenderer
            isFullScreen={isFullScreen}
            isDrag={isDrag}
            zoomInRef={zoomInRef}
            zoomOutRef={zoomOutRef}
            setDefaultStateRef={setDefaultStateRef}
            transformComponentRef={transformComponentRef}
        />
    );
}
function mapStateToProps(store: IStore, ownProps: OwnProps) {
    const inspectorStore = inspectorSelectors._getStore(store);
    const showCoverPages = inspectorSelectors.getShowCoverPages(inspectorStore);
    const stateOfScriptInjection =
        inspectorSelectors.getStateOfScriptInjection(inspectorStore);
    return {
        showCoverPages,
        stateOfScriptInjection,
    };
}
function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps) {
    return {};
}
const reduxConnector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof reduxConnector>;
export default reduxConnector(LogInspectorView);
